import { Button } from "@/components/flexkit/Button";
import { Card } from "@/components/flexkit/Card";
import { Text } from "@/components/podkit/typography/Text";
import { useListSubscriptions, useOrganization } from "@/queries/organization-queries";
import { computeCoreSubscriptionStatus } from "@/routes/settings/organization/billing/billing-utils";
import { CancelSubscriptionModal } from "@/routes/settings/organization/billing/CancelSubscriptionModal";
import { SubscriptionStatus } from "gitpod-next-api/gitpod/v1/billing_pb";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";
import { useCallback, useMemo, useState, type FC } from "react";

export const CancelPlanCard: FC = () => {
    const [showCancelModal, setShowCancelModal] = useState(false);

    const { data: organization } = useOrganization();

    const { data: subscriptions } = useListSubscriptions();
    const subscription = useMemo(() => {
        if (!subscriptions) {
            return undefined;
        }
        return computeCoreSubscriptionStatus(subscriptions);
    }, [subscriptions]);
    const isActive = subscription?.status === SubscriptionStatus.ACTIVE;

    const handleCancelClick = useCallback(() => {
        setShowCancelModal(true);
    }, []);

    const handleModalClose = useCallback(() => {
        setShowCancelModal(false);
    }, []);

    // Only show for Core tier organizations
    if (organization?.tier !== OrganizationTier.CORE) {
        return null;
    }

    return (
        <Card className="flex flex-col gap-6 bg-surface-glass p-6" variant="bordered">
            <div className="flex items-center justify-between">
                <div className="flex-1">
                    <h2 className="text-lg font-semibold text-content-primary">Cancel your plan</h2>
                    {isActive ? (
                        <Text className="text-sm text-content-secondary">You can cancel your plan here</Text>
                    ) : (
                        <Text className="text-sm text-content-secondary">Your plan is cancelled.</Text>
                    )}
                </div>
                <div className="flex flex-col justify-end">
                    <Button
                        variant="destructive"
                        disabled={!isActive}
                        onClick={handleCancelClick}
                        data-tracking-id="cancel-plan-cancel-plan-card"
                    >
                        Cancel
                    </Button>
                </div>
            </div>
            {showCancelModal && <CancelSubscriptionModal onClose={handleModalClose} />}
        </Card>
    );
};
